export default __webpack_public_path__ + "static/media/snowlogo.009cfd57.svg";